import CacPage from "@app/pages/cac/cac-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/cac")({
  head: () => pageHead("Fully Loaded CAC"),
  component: CacRoute,
});

function CacRoute() {
  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading CAC</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading CAC...</div>}
      >
        <CacPage />
      </Suspense>
    </ErrorBoundary>
  );
}
